import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-post-list',
  templateUrl: './section-post-list.component.html',
  styleUrls: ['./section-post-list.component.css']
})
export class SectionPostListComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

  callToActionButton(){
    /* goToEmbajadaRequisites */
  }

  openLink(link){
    window.open(link,'_blank');
  }

}
